import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, Menu, Search, X } from 'lucide-react';
import { useUserSettingsContext } from '../../../context/UserSettingsContext';
import NotificationCenter from '../../NotificationCenter/NotificationCenter';
import { useSidebar } from '../../ui/sidebar';
import OrgSwitcher from '../shell/OrgSwitcher';
import { useUnreadNotifications } from '../shell/useUnreadNotifications';
import { openCommandPalette } from '../shell/shellEvents';

function BarButton({ label, onClick, badge, children, ...rest }) {
  return (
    <button type="button" aria-label={label} onClick={onClick} className="app-m-barbtn" {...rest}>
      {children}
      {badge > 0 && <span className="app-m-badge">{badge > 99 ? '99+' : badge}</span>}
    </button>
  );
}

/**
 * Phone New look: the sidebar folded into a top bar. Painted in the viewer's
 * sidebar palette; the menu button unfolds the full sidebar as a sheet
 * underneath it (the bar stays put and its button becomes a close).
 */
export default function MobileAppBar() {
  const navigate = useNavigate();
  const { openMobile, setOpenMobile, toggleSidebar } = useSidebar();
  const { userSettings } = useUserSettingsContext();
  const { count: unread, refresh } = useUnreadNotifications(userSettings?.email);
  const [notificationsOpen, setNotificationsOpen] = useState(false);

  return (
    <div className="app-m-bar" data-mobile-appbar="">
      <BarButton
        label={openMobile ? 'Close menu' : 'Open menu'}
        aria-expanded={openMobile}
        data-mobile-sheet-toggle=""
        onClick={toggleSidebar}
      >
        {openMobile ? <X className="size-5" /> : <Menu className="size-5" />}
      </BarButton>
      <div className="app-m-org">
        <OrgSwitcher variant="appbar" />
      </div>
      <BarButton
        label="Search"
        onClick={() => {
          setOpenMobile(false);
          openCommandPalette();
        }}
      >
        <Search className="size-[18px]" />
      </BarButton>
      <div className="relative">
        <BarButton
          label="Notifications"
          badge={unread}
          onClick={() => {
            setOpenMobile(false);
            setNotificationsOpen((o) => !o);
            if (!notificationsOpen) refresh();
          }}
        >
          <Bell className="size-[18px]" />
        </BarButton>
        <NotificationCenter
          isOpen={notificationsOpen}
          onClose={() => setNotificationsOpen(false)}
          onNavigate={(path) => {
            navigate(path, { state: { forecastJump: Date.now() } });
            setNotificationsOpen(false);
          }}
          onNotificationRead={refresh}
        />
      </div>
    </div>
  );
}
